import { EventEmitter } from "eventemitter3";
export const planDetailEvent = new EventEmitter();
